import { RequestOriginGroup, RequestOriginKind, type RequestOrigins } from "./models";

export const ORIGIN_GROUP_BY_KIND: Readonly<Record<RequestOriginKind, RequestOriginGroup>> = {
	[RequestOriginKind.CallOff]: RequestOriginGroup.People,
	[RequestOriginKind.ReplaceRequest]: RequestOriginGroup.People,
	[RequestOriginKind.SwapRequest]: RequestOriginGroup.People,
	[RequestOriginKind.TimeOff]: RequestOriginGroup.People,
	[RequestOriginKind.TimeOffHris]: RequestOriginGroup.External,
	[RequestOriginKind.Deactivation]: RequestOriginGroup.People,
	[RequestOriginKind.PostedByPerson]: RequestOriginGroup.People,
	[RequestOriginKind.FromRecommendation]: RequestOriginGroup.People,
	[RequestOriginKind.PostedByAnnie]: RequestOriginGroup.People,
	[RequestOriginKind.AutoPost]: RequestOriginGroup.Automation,
	[RequestOriginKind.Agency]: RequestOriginGroup.External,
	[RequestOriginKind.AgencyCanceled]: RequestOriginGroup.Automation,
	[RequestOriginKind.CountRaised]: RequestOriginGroup.People,
};

/** The filter's display order. */
export const ORIGIN_GROUPS: readonly RequestOriginGroup[] = [RequestOriginGroup.Automation, RequestOriginGroup.People, RequestOriginGroup.External];

/** No groups chosen means no filter. A request matches when ANY of its causes is in a chosen group. */
export const matchesOriginGroups = (origins: RequestOrigins | undefined, groups: readonly RequestOriginGroup[]): boolean => {
	if (groups.length === 0) return true;
	if (origins === undefined) return false;
	return origins.openings.some((opening) => groups.includes(opening.group));
};

/** How many of `requestIds` have at least one cause in each group — a request with causes in two groups counts in both. */
export const countByOriginGroup = (requestIds: readonly string[], byRequestId: ReadonlyMap<string, RequestOrigins>): Record<RequestOriginGroup, number> => {
	const counts: Record<RequestOriginGroup, number> = {
		[RequestOriginGroup.Automation]: 0,
		[RequestOriginGroup.People]: 0,
		[RequestOriginGroup.External]: 0,
	};
	for (const id of requestIds) {
		const origins = byRequestId.get(id);
		if (origins === undefined) continue;
		for (const group of new Set(origins.openings.map((opening) => opening.group))) {
			counts[group] += 1;
		}
	}
	return counts;
};
